import Vue  from "vue";
import Router from "vue-router";
import Home from '@/views/HomeView.vue';

Vue.use(Router);
const router = new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
      // 如果有保存的位置（如浏览器前进后退），则返回保存的位置
      if (savedPosition) {
        return savedPosition;
      } else {
        // 否则滚动到页面顶部
        return { x: 0, y: 0 };
      }
    },
    routes: [
        {
          path: "/",
          name: "Home",
          component: Home
        },
    ]
});

// 添加全局路由守卫
router.beforeEach((to, from, next) => {
  // 添加3秒延迟来查看加载效果
  document.title = to.meta.title || 'KURPOT'
  next()
});

router.onError(error => {
  // 处理路由加载错误
  console.error('路由错误:', error)
  // 可以跳转到错误页面或显示提示
})

//解决 VueRouter 中同一路由多次切换报错问题
const original = Router.prototype.push;
Router.prototype.push = function push(location) {
    return original.call(this, location).catch(err => err)
};

export default router;